export const FETCH_CUSTOMERS_QUERY_KEY = 'fetchCustomers'
export const FETCH_BILLINGS_QUERY_KEY = 'fetchBillings'